import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { Range } from 'react-range';
import { AiFillStar } from 'react-icons/ai';
import { CiStar } from 'react-icons/ci';
import Products from '../components/products/Products';
import { BsFillGridFill } from 'react-icons/bs';
import { FaThList } from 'react-icons/fa';
import ShopProducts from '../components/products/ShopProducts';
import Pagination from '../components/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { price_range_product, query_wholesale_products } from '../store/reducers/homeReducer';
import { useCurrency } from '../context/CurrencyContext';

const WholesaleProducts = () => {
    const dispatch = useDispatch();
    const { wholesale_products, priceRange, latest_product, totalProduct, parPage } = useSelector(state => state.home);
    const { convertFromBase, convertToBase, formatDisplay, currency } = useCurrency();

    const [filter, setFilter] = useState(true);
    const [state, setState] = useState({ values: [convertFromBase(priceRange.low), convertFromBase(priceRange.high)] });
    const [rating, setRating] = useState('');
    const [styles, setStyles] = useState('grid');
    const [pageNumber, setPageNumber] = useState(1);
    const [sortPrice, setSortPrice] = useState('');

    useEffect(() => {
        dispatch(price_range_product());
    }, [dispatch]);

    useEffect(() => {
        setState({ values: [convertFromBase(priceRange.low), convertFromBase(priceRange.high)] });
    }, [priceRange, currency, convertFromBase]);

    useEffect(() => {
        dispatch(
            query_wholesale_products({
                low: Math.floor(convertToBase(state.values[0])) || '',
                high: Math.ceil(convertToBase(state.values[1])) || '',
                rating,
                sortPrice,
                pageNumber,
            })
        );
    }, [state.values, rating, sortPrice, pageNumber, dispatch, convertToBase]);

    const resetRating = () => {
        setRating('');
        dispatch(
            query_wholesale_products({
                low: Math.floor(convertToBase(state.values[0])),
                high: Math.ceil(convertToBase(state.values[1])),
                rating: '',
                sortPrice,
                pageNumber
            })
        );
    };

    return (
        <div>
            <Header />
            {/* Banner Section */}
            <section style={{ backgroundImage: "url('/images/banner/shop.png')" }} className='h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left'>
                <div className='absolute left-0 top-0 w-full h-full bg-[#2422228a]'>
                    <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
                        <div className='flex flex-col justify-center gap-1 items-center h-full w-full text-white'>
                            <h2 className='text-3xl font-bold'>Wholesale Products</h2>
                            <div className='flex justify-center items-center gap-2 text-2xl w-full'>
                                <Link to='/'>Home</Link>
                                <span className='pt-1'><IoIosArrowForward /></span>
                                <span>Wholesale Products</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Products Section */}
            <section className='py-16'>
                <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
                    <div className={`md:block hidden ${!filter ? 'mb-6' : 'mb-0'}`}>
                        <button onClick={() => setFilter(!filter)} className='text-center w-full py-2 px-3 bg-indigo-500 text-white'>Filter Product</button>
                    </div>

                    <div className='w-full flex flex-wrap'>
                        {/* Left Filter */}
                        <div className={`w-3/12 md-lg:w-4/12 md:w-full pr-8 ${filter ? 'md:h-0 md:overflow-hidden md:mb-6' : 'md:h-auto md:overflow-auto md:mb-0'}`}>
                            <div className='py-2 flex flex-col gap-5'>
                                <h2 className='text-3xl font-bold mb-3 text-slate-600'>Price</h2>
                                <Range
                                    step={5}
                                    min={convertFromBase(priceRange.low)}
                                    max={convertFromBase(priceRange.high)}
                                    values={state.values}
                                    onChange={(values) => setState({ values })}
                                    renderTrack={({ props, children }) => (
                                        <div {...props} className='w-full h-[6px] bg-slate-200 rounded-full cursor-pointer'>
                                            {children}
                                        </div>
                                    )}
                                    renderThumb={({ props }) => (
                                        <div className='w-[15px] h-[15px] bg-[#059473] rounded-full' {...props} />
                                    )}
                                />
                                <div>
                                    <span className='text-slate-800 font-bold text-lg'>
                                        {formatDisplay(Math.floor(state.values[0]))} - {formatDisplay(Math.floor(state.values[1]))}
                                    </span>
                                </div>
                            </div>

                            <div className='py-3 flex flex-col gap-4'>
                                <h2 className='text-3xl font-bold mb-3 text-slate-600'>Rating</h2>
                                <div className='flex flex-col gap-3'>
                                    {[5, 4, 3, 2, 1].map((num) => (
                                        <div key={num} onClick={() => setRating(num)} className='text-orange-500 flex gap-2 text-xl cursor-pointer'>
                                            {[...Array(5)].map((_, i) => i < num ? <AiFillStar key={i} /> : <CiStar key={i} />)}
                                        </div>
                                    ))}
                                    <div onClick={resetRating} className='text-orange-500 flex gap-2 text-xl cursor-pointer'>
                                        {[...Array(5)].map((_, i) => <CiStar key={i} />)}
                                    </div>
                                </div>
                            </div>

                            <div className='py-5 flex flex-col gap-4 md:hidden'>
                                <Products title='Latest Product' products={latest_product} />
                            </div>
                        </div>

                        {/* Right Content */}
                        <div className='w-9/12 md-lg:w-8/12 md:w-full'>
                            <div className='pl-8 md:pl-0'>
                                <div className='py-4 bg-white mb-10 px-3 rounded-md flex justify-between items-start border'>
                                    <h2 className='text-lg font-medium text-slate-600'>({totalProduct}) Products</h2>
                                    <div className='flex justify-center items-center gap-3'>
                                        <select onChange={(e) => setSortPrice(e.target.value)} className='p-1 border outline-0 text-slate-600 font-semibold'>
                                            <option value=''>Sort By</option>
                                            <option value='low-to-high'>Low to High Price</option>
                                            <option value='high-to-low'>High to Low Price</option>
                                        </select>
                                        <div className='flex justify-center items-start gap-4 md-lg:hidden'>
                                            <div onClick={() => setStyles('grid')} className={`p-2 ${styles === 'grid' && 'bg-slate-300'} text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm`}>
                                                <BsFillGridFill />
                                            </div>
                                            <div onClick={() => setStyles('list')} className={`p-2 ${styles === 'list' && 'bg-slate-300'} text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm`}>
                                                <FaThList />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='pb-8'>
                                    <ShopProducts products={wholesale_products || []} styles={styles} />
                                </div>

                                <div>
                                    {totalProduct > parPage && (
                                        <Pagination
                                            pageNumber={pageNumber}
                                            setPageNumber={setPageNumber}
                                            totalItem={totalProduct}
                                            parPage={parPage}
                                            showItem={Math.floor(totalProduct / parPage)}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default WholesaleProducts;
